import {IMessageData, IObjectData, IRouteDefinitionParams, ISyncField} from "../../index";
import * as ko from "knockout";
import {createErrorMessage} from "../../util/misc";
import {_} from 'lodash';
import {nsRoute} from "../../util/route";
import {REQUEST_MESSAGE} from "../../constants/Language";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;

export default abstract class ObjectDetails<TData extends IObjectData = IObjectData> extends ParsedRouteDataDecorator {

    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    isReady: KnockoutObservable<boolean> = ko.observable(false);
    data: KnockoutObservable<TData | null> = ko.observable(null);

    constructor(params: IRouteDefinitionParams, autoRequest = true) {
        super(params);
        if (autoRequest) {
            this.request();
        }
    }

    protected request(): Promise<any> {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        return this.__requestRouteData!
            .request()
            .then((data: any[]) => this.onSuccess(data as [TData]))
            .catch(this.onError.bind(this))
    }

    protected onSuccess(data: [TData]): Promise<[TData]> {
        const d = data[0];
        d.syncfields = _.sortBy(d.syncfields, (item: ISyncField) => item.name.toLowerCase());
        this.data(d);
        return Promise.resolve(data);
    }

    protected onError(reason: string) {
        this.messageData(createErrorMessage(reason, `Klarte ikke å laste data.`));
    }

}